import type { TypeBody } from '@/shared/api/generated/model';

import { PAGES_SLUG } from './useSchemaTypes';

/**
 * Модель, чьи записи — страницы сайта: у неё есть адрес записи и поле из
 * блоков. Статьи блога, кейсы, услуги — в «Страницах» они папками, по
 * модели на папку (решение Давида 21 октября 2026).
 */
export function isPageModel(type: TypeBody): boolean {
  return (
    type.kind === 'collection' &&
    type.slug !== PAGES_SLUG &&
    type.deleted_at === undefined &&
    type.route !== '' &&
    type.blocks_field !== ''
  );
}

/** Адрес записи на сайте по шаблону модели: «/case/{slug}» → «/case/orange». */
export function recordPath(
  route: string,
  record: { id: string; slug?: string | null | undefined },
): string {
  return route.replaceAll('{slug}', record.slug ?? record.id).replaceAll('{id}', record.id);
}

/** Шаблон адреса для подписи папки: «/case/{slug}» → «/case/…». */
export function routePattern(route: string): string {
  return route.replaceAll('{slug}', '…').replaceAll('{id}', '…');
}
